import { useHttpService } from "@shared/services";
import { useCallback } from "react";

/** 可以把 1Template1 Replace all 成 API名稱！ */
export function useEventApi() {
  const http = useHttpService();

  /**
   * 取得所有活動資料
   */
  const GetAll = useCallback(async () => {
    return (
      await http.get<{
        success: boolean;
        events: Array<any>
      }>("/config/management/events")
    )?.data;
  }, [http]);

  /**
   * 新增活動
   */
  const Create = useCallback(
    async (eventID: number, eventName: string, remarks: string) => {
      return (
        await http.post<{
          success: boolean;
        }>("/config/management/events", {
          eventID,
          eventName,
          remarks,
        })
      )?.data;
    },
    [http]
  );

  /**
   * 更新活動
   */
  const Update = useCallback(
    async (
      eventID: number,
      eventName: string,
      remarks: string,
      eventArchived: boolean
    ) => {
      return (
        await http.put<{
          success: boolean;
        }>(`/config/management/event/${eventID}`, {
          eventName,
          remarks,
          eventArchived
        })
      )?.data;
    },
    [http]
  );

  /**
   * 刪除活動
   */
  const Delete = useCallback(
    async (eventID: number) => {
      return (
        await http.delete<{
          success: boolean;
        }>(`/config/management/event/${eventID}`)
      )?.data;
    },
    [http]
  );

  /**
   * 取得活動設定
   */
  const GetConfig = useCallback(
    async (eventID: number) => {
      return (
        await http.get<{
          success: boolean;
          configs: {};
        }>(`/config/management/event/${eventID}`)
      )?.data;
    },
    [http]
  );

  /**
   * 更新活動設定
   */
  const UpdateConfig = useCallback(
    async (
      eventID: number,
      systemKey: string,
      eventConfig: string,
      remarks: string
    ) => {
      return (
        await http.put<{
          success: boolean;
          configs: {};
        }>(`/config/management/event/${eventID}/config/${systemKey}`, {
          eventConfig,
          remarks,
        })
      )?.data;
    },
    [http]
  );
  /** 這裡導出可以用的API函數！ */
  return { GetAll, Create, Update, Delete, GetConfig, UpdateConfig };
}
